var _circle, _mask, _path, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkTypeDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.7246,
    cy: 16.0005,
    r: 15.25,
    stroke: "#3C4D6A",
    strokeWidth: 1.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_10350_55639",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7246 32C20.3825 28.2439 22.7246 22.4723 22.7246 16C22.7246 9.52766 20.3825 3.75605 16.7246 0C13.0668 3.75605 10.7246 9.52766 10.7246 16C10.7246 22.4723 13.0668 28.2439 16.7246 32Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7246 32L15.65 33.0465L16.7246 34.15L17.7992 33.0465L16.7246 32ZM16.7246 0L17.7992 -1.04652L16.7246 -2.14998L15.65 -1.04652L16.7246 0ZM21.2246 16C21.2246 22.126 19.0055 27.5079 15.65 30.9535L17.7992 33.0465C21.7594 28.98 24.2246 22.8187 24.2246 16H21.2246ZM15.65 1.04652C19.0055 4.49208 21.2246 9.87399 21.2246 16H24.2246C24.2246 9.18133 21.7594 3.02002 17.7992 -1.04652L15.65 1.04652ZM12.2246 16C12.2246 9.87399 14.4437 4.49208 17.7992 1.04652L15.65 -1.04652C11.6898 3.02002 9.22461 9.18133 9.22461 16H12.2246ZM17.7992 30.9535C14.4437 27.5079 12.2246 22.126 12.2246 16H9.22461C9.22461 22.8187 11.6898 28.98 15.65 33.0465L17.7992 30.9535Z",
    fill: "#3C4D6A",
    mask: "url(#path-2-inside-1_10350_55639)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 29.7246,
    y1: 8.75049,
    x2: 3.72461,
    y2: 8.75049,
    stroke: "#3C4D6A",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 31.7246,
    y1: 16.7505,
    x2: 0.724609,
    y2: 16.7505,
    stroke: "#3C4D6A",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 29.7246,
    y1: 23.7505,
    x2: 3.72461,
    y2: 23.7505,
    stroke: "#3C4D6A",
    strokeWidth: 1.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 30.832,
    y1: 32.7505,
    x2: 1.47489,
    y2: 32.7505,
    stroke: "#3C4D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkTypeDesktop);
export default __webpack_public_path__ + "static/media/network_type_desktop.e6e058624f5666cd9cf005b3d358b341.svg";
export { ForwardRef as ReactComponent };